import { Button } from "../components/Button";
import { useState } from "react";
import { CancelJobForm } from "./CancelJobForm";

interface CancelJobButtonProps {
    bookingId: string;
    mpan: string;
    serviceLine: string;
}

export const CancelJobButton = ({ bookingId, mpan, serviceLine }: CancelJobButtonProps) => {
    const [showForm, setShowForm] = useState(false);

    return (
        <div>
            <Button text="Cancel Job" primary={false} onClick={() => setShowForm(true)} disabled={false} className="mt-2 text-nowrap" widthStyling="w-full" />
            {showForm && <CancelJobForm bookingId={bookingId} mpan={mpan} serviceLine={serviceLine} closeForm={() => setShowForm(false)}/>}
        </div>
    )
}
